import React, { ReactElement, forwardRef } from 'react';

import { useAppSelector } from 'store/store-hooks';
import { selectHelpMode } from 'components/app/_mediator/app-data.slice';

import { Button } from 'components/UI/button/button';
import { TooltipPosition, Tooltip } from 'components/UI/tooltip/tooltip';

interface Props extends React.ComponentProps<typeof Button> {
  tip?: string | ReactElement;
  tipPosition?: TooltipPosition;
  showTooltip?: boolean;
}

export const AppButton = forwardRef<HTMLButtonElement, Props>(
  ({ children, tip, tipPosition, showTooltip, ...rest }, ref) => {
    const helpMode = useAppSelector(selectHelpMode);
    const showTip = showTooltip ? showTooltip : helpMode;
    return (
      <Tooltip tip={tip} showTooltip={showTip} position={tipPosition}>
        <Button ref={ref} {...rest}>
          {children}
        </Button>
      </Tooltip>
    );
  }
);
AppButton.displayName = 'AppButton';
